import { Component } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  ngOnInit()
  {
 
  }
}



// WEBPACK FOOTER //
// E:/Angular/website-angular/src/app/app.component.ts